module.exports = __webpack_public_path__ + "static/media/wallfinishes_allImpact_60yd_y.26e217aa.csv";